<div class="modal-header">
    <h4 class="modal-title"><strong>Estrategia {{data.strategy.name}} - Cargar arte</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        
        <mat-divider></mat-divider>

        <div class="container-fluid mt-2">
            <div class="row col-12">
                <div class="col-md-6">
                   <label class="fw-bold">Seleccionar un Producto</label>
                   <mat-form-field class="w-100 sel-inv" appearance="outline">
						<input type="text" style="padding-top: 3px !important;"
							placeholder="Buscar..."
							matInput
							[formControl]="materialControl"
							[matAutocomplete]="auto"
                            (focus)="openDropdown()">
							<button
								*ngIf="materialControl.value"
								mat-icon-button
								matSuffix
								(click)="clearAutocomplete()"
								aria-label="Clear">
								<mat-icon>close</mat-icon>
							</button>
						<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="seleccionarOpcion($event)">
						<mat-option *ngFor="let producto of filteredOptions | async" [value]="producto">
							{{producto.family }}
						</mat-option>
						</mat-autocomplete>
					</mat-form-field>


                   <div *ngIf="productSelect != null" class="mt-1">
                        <label *ngIf="productSelect.varias != true ">Medida: {{ productSelect?.ancho }}{{ productSelect?.unidad }} x {{ productSelect?.alto }}{{ productSelect?.unidad }}</label>
                        <label *ngIf="productSelect.varias == true ">Medida: Varias</label>
                    </div>
                   <div *ngIf="productSelect != null" class="mt-1">
                        <label>Acabado: {{ productSelect?.acabado }} - Tintas: {{ productSelect?.tintas }}</label>
                   </div>
                   
                </div>
                <!-- Imagen de producto seleccionado -->
                <div  *ngIf="productSelect != null" class="col-md-6">
                    <img [src]="fileUrl" alt="producto" />
                </div>
            </div>
        </div>
 
    </div>

    <div *ngIf="productSelect != null"  class="modal-footer mt-3 me-5 d-flex align-items-center gap-2">
        <form [formGroup]="form" class="d-flex align-items-center gap-2 mb-0">
            <input #pdfInput type="file" accept="application/pdf,.pdf" hidden (change)="onFileSelected($event)">
            <button mat-flat-button type="button" (click)="pdfInput.click()" class="bg-info text-white d-inline-flex align-items-center">
                <mat-icon>upload_file</mat-icon>
                Elegir PDF...
            </button>
            <span class="ms-1" *ngIf="form.get('blob')?.value?.length">
                {{ form.get('blob')?.value[0].name }}
            </span>
        </form>
        <button *ngIf="form.get('blob')?.value?.length" mat-flat-button class="bg-success text-white d-inline-flex align-items-center" (click)="saveDistributionArt(data.strategy.id)" >
            <mat-icon>check</mat-icon>
            Confirmar carga
        </button>
    </div>
</mat-dialog-content>
